export default {
	field: 'part.provider.name',
	name: 'Mfr',
}
